<template>
  <div>
    <WebHeaderView :title="$t('menu.turnover')" />
    <div class="page-content">
      <van-tabs
        @click="tabClick"
        v-model="active"
        color="#fff"
        title-active-color="#fff"
        style="margin-bottom: 10px"
      >
        <van-tab
          v-for="(item, index) in typeLst"
          :key="index"
          :title="item.name"
          :name="item.key"
        />
      </van-tabs>
      <van-row
        style="border-bottom: 1px solid grey; padding: 10px 0; font-size: 14px"
      >
        <van-col span="12">
          <span @click="toShow(0)"
            >{{ platname }}<van-icon name="arrow-down"
          /></span>
        </van-col>
        <van-col span="12">
          <span @click="toShow(1)"
            >{{ timename }}<van-icon name="arrow-down"
          /></span>
        </van-col>
      </van-row>
      <div style="width: 94%; margin: 0 auto">
        <div
          v-if="this.params.type == 116"
          style="
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 30px;
          "
          @click="lingqu"
        >
          累计领取 {{ jisuan }} 待领取{{ nojisuan }} <span>点击领取</span>
        </div>
        <div
          v-if="this.params.type == 7"
          style="
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 30px;
          "
        >
          累计领取 {{ jisuan }}
        </div>
      </div>
      <div class="list-record-box" v-if="list">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div v-for="(item, index) in list" :key="index">
              <TransreCordItemView
                :item="item"
                :type="params.type"
                v-if="
                  params.type == 1 ||
                  params.type == 2 ||
                  params.type == 3 ||
                  params.type == 4 ||
                  params.type == 5
                "
              />
              <BetItemView :item="item" v-if="params.type == 6" />
              <FanShuiItemView :item="item" v-if="params.type == 7" />
              <TaskFlowItemView :item="item" v-if="params.type == 8" />
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <van-popup v-if="apishow" v-model="apishow" position="bottom">
      <van-picker
        show-toolbar
        :columns="dataInfo"
        @confirm="onPlatConfirm"
        @cancel="onCancel"
        :label-key="'text'"
        :confirm-button-text="'确定'"
        :cancel-button-text="'取消'"
      />
    </van-popup>
    <van-popup v-model="timeshow" position="bottom" v-if="timeshow">
      <van-picker
        show-toolbar
        :columns="timeLst"
        @confirm="onTimeConfirm"
        @cancel="onCancel"
        :value-key="'text'"
        :confirm-button-text="'确定'"
        :cancel-button-text="'取消'"
      />
    </van-popup>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
import {
  TransreCordItemView,
  BetItemView,
  FanShuiItemView,
  TaskFlowItemView
} from './components/index'
export default {
  name: 'TurnoverView',
  components: {
    WebHeaderView,
    TransreCordItemView,
    BetItemView,
    FanShuiItemView,
    TaskFlowItemView
  },
  data () {
    return {
      active: 0,
      typeLst: [
        {name:this.$t('turnover.type0'),key:1},
        {name:this.$t('turnover.type1'),key:2},
        {name:'IM',key:5},
        {name:this.$t('turnover.type2'),key:3},
        
        {name:this.$t('turnover.type3'),key:4},
        {name:this.$t('turnover.type4'),key:6},
        {name:this.$t('turnover.type5'),key:7},
        {name:this.$t('turnover.type6'),key:8}
      ],
      timeLst: [
        { value: 1, text: this.$t('turnover.today') },
        { value: 2, text: this.$t('turnover.week') },
        { value: 3, text: this.$t('turnover.halfmonth') },
        { value: 4, text: this.$t('turnover.month') }
      ],
      dataInfo: [],
      apishow: false,
      platname: this.$t('turnover.all'),
      timeshow: false,
      timename: '',
      params: {
        date: 1,
        api_type: '',
        page: 1,
        type: 1
      },
      list: [],
      isLoading: false,
      loading: false,
      finished: false,
      jisuan: 0,
      nojisuan: 0
    }
  },
  mounted () {
    const query = this.$route.query
    if (query.type) {
      this.params.type = query.type
      this.active = parseInt(query.type)
    }

    this.timename = this.timeLst[0].text
    this.getBalanCelist()
  },
  methods: {
    toShow (val) {
      const that = this
      this.$nextTick(() => {
        if (val == 0) that.apishow = true
        if (val == 1) that.timeshow = true
      })
    },
    onCancel () {
      this.apishow = false
      this.timeshow = false
    },
    onPlatConfirm (val) {
      this.platname = val.text
      this.params.api_type = val.value
      this.onCancel()
      this.onRefresh()
    },
    onTimeConfirm (val) {
      this.timename = val.text
      this.params.date = val.value
      this.onCancel()
      this.onRefresh()
    },
    async getBalanCelist () {
      await this.$http({
        method: 'post',
        url: 'balanCelist'
      }).then(data => {
        this.dataInfo = [{ value: '', text: this.$t('turnover.all') }]
        let tmp = ''
        data.data.forEach(item => {
          if (tmp.indexOf(',' + item.platname) == -1) {
            tmp += ',' + item.platname
            this.dataInfo.push({ value: item.platname, text: item.name })
          }
        })
        console.log(this.dataInfo)
      })
    },
    tabClick (val) {
      this.list = []
      this.params.type = val
      this.params.page = 1
      this[`getList${val}`]()
    },
    onRefresh () {
      this.list = []
      this.params.page = 1
      this.onLoad()
    },
    onLoad () {
      this[`getList${this.params.type}`]()
      this.isLoading = false
    },
    getList1 () {
      this.getTransrecord()
    },
    getList2 () {
      this.getTransrecord()
    },
    getList3 () {
      this.getTransrecord()
    },
    getList4 () {
      this.getTransrecord()
    },
    getList5 () {
      this.getTransrecord()
    },
    getList6 () {
      this.getUsrBetrecord()
    },
    getList7 () {
      this.getUsrfanshui()
    },
    getList8 () {
      this.getUsrFlow()
    },
    async getTransrecord () {
      await this.$http({
        method: 'post',
        url: 'transrecord',
        data: this.params
      })
        .then(data => {
          this.finished = this.list.length >= data.data.total
          if (!this.finished) this.params.page += 1
          this.loading = false
          if (this.params.page == 1) {
            this.list = data.data.list.data
          } else {
            this.list = this.list.concat(data.data.data)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    async getUsrBetrecord () {
      let tmpparams = JSON.parse(JSON.stringify(this.params))
      tmpparams.type = ''
      await this.$http({
        method: 'post',
        url: 'usrBetrecord',
        data: tmpparams
      })
        .then(data => {
          this.finished = this.list.length >= data.data.list.total
          if (!this.finished) this.params.page += 1
          this.loading = false
          if (this.params.page == 1) {
            this.list = data.data.list.data
          } else {
            this.list = this.list.concat(data.data.list.data)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    async getUsrfanshui () {
      let tmpparams = JSON.parse(JSON.stringify(this.params))
      tmpparams.type = ''
      await this.$http({
        method: 'post',
        url: 'fanshui',
        data: tmpparams
      })
        .then(data => {
          this.finished = this.list.length >= data.data.list.total
          if (!this.finished) this.params.page += 1
          this.loading = false
          if (this.params.page == 1) {
            this.list = data.data.list.data
          } else {
            this.list = this.list.concat(data.data.list.data)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    async getUsrFlow () {
      let tmpparams = JSON.parse(JSON.stringify(this.params))
      tmpparams.type = ''
      await this.$http({
        method: 'post',
        url: 'getFlow',
        data: tmpparams
      })
        .then(data => {
          this.finished = this.list.length >= data.data.list.total
          if (!this.finished) this.params.page += 1
          this.loading = false
          if (this.params.page == 1) {
            this.list = data.data.list.data
          } else {
            this.list = this.list.concat(data.data.list.data)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    async lingqu () {
      let that = this
      let fanshui = that.nojisuan
      if (fanshui <= 0) {
        this.$toast.fail('暂无领取额度！')
        return
      }
      await this.$http({
        method: 'post',
        url: 'transrecord',
        data: this.params
      }).then(data => {
        this.$toast.success(data.msg)
        that.params.page = 1
        that.getList6()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.list-record-box {
  margin-top: 15px;
  height: calc(100vh - 170px);
  width: 96%;
  margin: 0 auto;
  overflow: auto;
}
</style>
